<template>
  <div>
  <MenuSidebar />
  <h1>Welcome to the Oddball Game!</h1>
  <small>Questions? Comments? Suggestions? Find me on github at <a href="https://github.com/curtisahuang/">curtisahuang</a></small>
  </div>
</template>

<script>
import MenuSidebar from "./MenuSidebar.vue"
export default {
  components: { MenuSidebar },
}
</script>

<style>
</style>